// extracted by mini-css-extract-plugin
export default {"ellipse":"TransportStatusIconAndLabel_ellipse__LIOBX"};